import AddressForm from "components/AddressForm"
import VueComponent from "../vue_component"

export default VueComponent(AddressForm)
